<template>
  <v-layout row wrap class="nx-authorization-permissions-wizard-content-filters">
    <component
      v-for="(component, index) in availableFilters"
      :key="`${index}-${component.name}`"
      :is="component"
      v-model="filterValues[index]"
      v-if="showFilter(index)"
    ></component>
  </v-layout>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'nx-authorization-permissions-wizard-filters',
  data() {
    return {
      filterValues: [],
    };
  },
  props: {
    availableFilters: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    filters() {
      return Object
        .keys(this.filterValues)
        .reduce((result, filter) => {
          if (isEmpty(this.filterValues[filter])) {
            return {};
          }
          return { ...result, ...this.filterValues[filter] };
        }, {});
    },
  },
  methods: {
    showFilter(index) {
      if (index === 0) {
        return true;
      }
      return !isEmpty(this.filterValues[index - 1]);
    },
  },
  watch: {
    filters(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="stylus">
.nx-authorization-permissions-wizard-content-filters {
  .v-input--radio-group__input {
    justify-content: space-between;
  }
}
</style>
